
<template>
  <div class="sticker-wrap" v-if="imgList && imgList.length > 0">
    <!-- 英文版 -->
    <div v-for="(tag, index) in imgList" :key="index" v-if="CookiesOne==='en-US'"> 
      <img :src="tag.mktIcon" v-if="tag.type == '2' && tag.mktIcon" alt="爆炸贴" />
    </div>
    <!-- 中文版 -->
    <div v-for="(tag, index) in imgList" :key="index" v-if="CookiesOne!=='en-US'"> 
      <img :src="tag.mktIcon" v-if="tag.type == '2' && tag.mktIcon" alt="爆炸贴" />
    </div>
  </div>
  <!-- <div class="sticker-wrap">
    <div>
      <img src="./sticker.png" alt="爆炸贴" />
    </div>
  </div> -->
</template>

<script>
import Cookies from 'js-cookie';
export default {
  name: "Sticker",
  props: {
    imgList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      CookiesOne:Cookies.get('df_lang'),
    }
  },
};
</script>

<style lang="less" scoped>
.sticker-wrap img {
  position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>